export const barChartHorizontalI18NDe = {
    projectName: "Projektname",
    username: "Benutzername",
    time: "Zeit",
};
